import React from "react";
import "./MessageModal.scss";

interface MessageModalProps {
  message: string;
  isOpen: boolean;
  onClose: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({
  message,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modalWrap" onClick={onClose}>
      <div className="modalBox">
        <div className="modalInner">{message}</div>
      </div>
    </div>
  );
};

export default MessageModal;
